import axios from 'axios';
import _ from 'lodash';
import {
  SET_ORIGINAL_RATE_JSON,
  SET_SEA_FCL_JSON,
  SET_SEA_LCL_JSON,
  SET_AIR_JSON,
  SET_NEW_RATE_REMAINING_TIME,
  SET_NEW_RATES_APPEAR,
  SEARCH_SHOW_NEW_RATE_CONTACT_FORM,
  SET_SEARCH_CUSTOM_MESSAGE_JSON,
  UPDATE_PICKUP_DELIVERY_ERS_LINE,
} from '../actions/types';
import {
  API_KEY,
  AUTH_TOKEN,
  NEW_RATES_BY_UUID_GET_URL,
  SHOW_CONTACT_FORM_AFTER_UUID_PC_TIME_PASSED,
} from '../envVariables';
import { isEmpty } from './isEmpty';
import { isDevENV } from './isDevENV';
import {
  sortCards,
  updateJsonAfterPostalSubmit,
  updateRateCardsInfo,
} from '../actions';
import { getTimeInMinSec } from './getTimeInMinSec';
import { updateSidebarRoleIncoterm } from './updateSidebarRoleIncoterm';

/**
 * @memberof module:util
 * @function
 * @name getNewRatesByUUID
 * @description It gets new rate cards by UUID. It also manages old rate cards and new rate cards.
 *
 * @param {Object} queryParams - It is the query params built from Url (not from redux store) for Search page.
 * It's from redux store for Form page.
 * @param {Object} resRate - Full rate json
 * @param {Function} dispatch - It dispatches a Redux Action
 * @param {Redux.Store} getState - Whole Redux Store State
 * @returns {void}
 */

// queryParams from route-actions not from store for search page
//queryParams from redux store for form page
const getNewRatesByUUID = async (queryParams, resRate, dispatch, getState) => {
  // console.log('resRate', resRate);

  //save json
  saveOriginalRate(resRate, dispatch);

  // update custom message
  updateCustomMessage(resRate, dispatch);

  // clear timer id for new search click post request
  if (window.new_rate_timer_id) {
    clearInterval(window.new_rate_timer_id);
  }
  // clear remaining time id for new search click post request
  clearRemainingTimeInterval(dispatch);
  // set null for first time
  // it is used for showing contact form if no rates appear at all
  dispatch({
    type: SET_NEW_RATES_APPEAR,
    payload: null,
  });
  //hide search contact form
  dispatch({
    type: SEARCH_SHOW_NEW_RATE_CONTACT_FORM,
    payload: false,
  });

  // if (window.new_rate_remaining_timer_id) {
  //   clearInterval(window.new_rate_remaining_timer_id);
  //   dispatch({
  //     type: SET_NEW_RATE_REMAINING_TIME,
  //     payload: '', //remaining time = ""
  //   });
  // }

  let finalRateJson = {};
  let req_uuid = resRate && resRate.req_uuid; //uuid

  // if no uuid is present in resRate then clear the timer and return
  if (!req_uuid) {
    return finalRateJson;
  }

  // if number of tries is zero then return
  let no_of_tries = Number(resRate.no_of_tries);
  no_of_tries = isNaN(no_of_tries) ? 0 : no_of_tries;

  console.log('no_of_tries: ', no_of_tries);
  if (no_of_tries === 0) {
    return;
  }

  //if uuid present, i.e. "req_uuid"
  dispatch({
    type: SET_ORIGINAL_RATE_JSON, //originalRateData
    payload: {
      loading: true,
    },
  });

  const inputParams = {
    apiKey: API_KEY,
    Authorization: `Bearer ${AUTH_TOKEN}`,

    req_uuid_url_param: getState().code_config.uuidUrlParamsObj.req_uuid,
    uuid_verification_url_param: getState().code_config.uuidUrlParamsObj
      .uuid_verification,

    user: getState().code_config.initAuth.user,
    verification: getState().code_config.initAuth.verification,
    req_uuid,
    type: queryParams.type,
  };

  // run a timer
  let timein_ms = Number(resRate.req_interval * 1000);
  timein_ms = isNaN(timein_ms) ? 0 : timein_ms;

  window.new_rate_no_of_tries = 0;

  let response = {};

  // total init seconds
  let originalTotalTime_sec = (no_of_tries * timein_ms) / 1000;
  window.remaining_time_sec = (no_of_tries * timein_ms) / 1000;
  // run a setinterval in each 1 sec for showing remaining time
  window.new_rate_remaining_timer_id = setInterval(() => {
    if (
      timein_ms &&
      no_of_tries &&
      req_uuid &&
      window.new_rate_no_of_tries < no_of_tries &&
      window.new_rate_remaining_timer_id
    ) {
      // show contact form or not
      const passedTimePc = Math.ceil(
        ((originalTotalTime_sec - window.remaining_time_sec) * 100) /
          originalTotalTime_sec
      );
      toggleContactForm(
        passedTimePc,
        dispatch,
        getState().route.newRatesAppear
      );
      dispatch({
        type: SET_NEW_RATE_REMAINING_TIME,
        payload: getTimeInMinSec(window.remaining_time_sec),
      });
      window.remaining_time_sec = --window.remaining_time_sec;
    } else {
      clearRemainingTimeInterval(dispatch);
    }
  }, 1000);

  // run  timer for getting new rates by uuid
  window.new_rate_timer_id = setInterval(async () => {
    // if timein_ms non zero and req_uuid is present
    if (
      timein_ms &&
      no_of_tries &&
      req_uuid &&
      window.new_rate_no_of_tries < no_of_tries &&
      window.new_rate_timer_id
    ) {
      try {
        let newRateURL;
        // it's for test only
        if (isDevENV()) {
          newRateURL = NEW_RATES_BY_UUID_GET_URL + '/search-rates';
        } else {
          newRateURL = NEW_RATES_BY_UUID_GET_URL;
        }
        response = await axios.get(newRateURL, {
          params: inputParams,
        });

        window.new_rate_no_of_tries = 1 + window.new_rate_no_of_tries;

        console.log('window.new_rate_no_of_tries', window.new_rate_no_of_tries);

        // clear timer if no uuid present
        if (isEmpty(response.data) || !response.data.req_uuid) {
          clearMyInterval(dispatch);
          clearRemainingTimeInterval(dispatch);
        }

        //save only if it's not empty/falsy
        if (!isEmpty(response.data)) {
          saveNewRateJSON(response.data, queryParams, getState, dispatch);
        }
      } catch (err) {
        console.log(err);
        window.new_rate_no_of_tries = 1 + window.new_rate_no_of_tries;

        console.log('window.new_rate_no_of_tries', window.new_rate_no_of_tries);
      }
    } else {
      clearMyInterval(dispatch);
      clearRemainingTimeInterval(dispatch);
    }
  }, timein_ms);
};

export default getNewRatesByUUID;

// save original rates
const saveOriginalRate = (rates, dispatch) => {
  //save json
  dispatch({
    type: SET_ORIGINAL_RATE_JSON, //originalRateData
    payload: {
      rateJson: rates,
      loading: false,
    },
  });
  // console.log('rate is saved*************');
};

// clear interval timer
const clearMyInterval = (dispatch) => {
  console.log('clearMyInterval');

  if (window.new_rate_timer_id) {
    clearInterval(window.new_rate_timer_id);
  }
  dispatch({
    type: SET_ORIGINAL_RATE_JSON, //originalRateData
    payload: {
      loading: false,
    },
  });
};

// clear remaining timer
const clearRemainingTimeInterval = (dispatch) => {

  if (window.new_rate_remaining_timer_id) {
    clearInterval(window.new_rate_remaining_timer_id);
  }
  dispatch({
    type: SET_NEW_RATE_REMAINING_TIME,
    payload: '',
  });
};

// whether show contact form
const toggleContactForm = (passedTimePc, dispatch, newRatesAppear) => {
  // console.log('pc passedTimePc', passedTimePc);
  let envUuidPcTimePassesd = Number(
    SHOW_CONTACT_FORM_AFTER_UUID_PC_TIME_PASSED
  );
  envUuidPcTimePassesd = envUuidPcTimePassesd <= 0 ? 100 : envUuidPcTimePassesd;

  envUuidPcTimePassesd = isNaN(envUuidPcTimePassesd)
    ? 100
    : envUuidPcTimePassesd;

  // console.log('envUuidPcTimePassesd----------------', envUuidPcTimePassesd);

  if (passedTimePc < envUuidPcTimePassesd) {
    // console.log('return now');
    return;
  }

  if (!newRatesAppear) {
    console.log('SEARCH_SHOW_NEW_RATE_CONTACT_FORM now');
    dispatch({
      type: SEARCH_SHOW_NEW_RATE_CONTACT_FORM,
      payload: true,
    });
  } else {
    console.log('newRatesAppear is already present, do not show contact form');
  }
};

//new rate + old rate json
const saveNewRateJSON = (newRateJson, queryParams, getState, dispatch) => {
  // if type saved and new rates json type doesn't match then return
  let newJsonTypekey =
    newRateJson && newRateJson.rates && Object.keys(newRateJson.rates);

  // if new json has no array or empty type then return
  if (!Array.isArray(newJsonTypekey) || !newJsonTypekey[0]) {
    return;
  }

  // check for new empty array rate items
  // set whether new rates appear or not in newRateJson and update redux store
  const newRatesPresent =
    newRateJson &&
    newRateJson.rates &&
    Array.isArray(newRateJson.rates[newJsonTypekey[0]]) &&
    newRateJson.rates[newJsonTypekey[0]].length > 0;

  // update redux store
  // if rates already appeared before then don't update it
  // it is used for showing contact form if no rates appear at all
  if (!getState().route.newRatesAppear && newRatesPresent) {
    console.log('im here saveNewRateJSON--');

    dispatch({
      type: SET_NEW_RATES_APPEAR,
      payload: true,
    });
  }

  newJsonTypekey = newJsonTypekey && `api-${newJsonTypekey[0]}`;

  // original rates
  const originalRateJson = getState().route.originalRateData.rateJson;

  let originalJsonType =
    originalRateJson &&
    originalRateJson.rates &&
    Object.keys(originalRateJson.rates);
  originalJsonType = originalJsonType && `api-${originalJsonType[0]}`;

  console.log(
    'originalJsonType, newJsonTypekey: ',
    originalJsonType,
    newJsonTypekey
  );

  if (originalJsonType !== newJsonTypekey) {
    return;
  }

  let correctJson = {};
  if (queryParams.type === 'api-fcl') {
    const newJsonArr =
      newRateJson && newRateJson.rates && newRateJson.rates.fcl;
    console.log('newJsonArr', newJsonArr);
    // if newJsonArr is empty then return
    if (Array.isArray(newJsonArr) && newJsonArr.length === 0) {
      console.log('empty newJsonArr, return');
      // if newJsonArr is empty then return
      return;
    }
    // old json rates fcl array + new json rates array
    correctJson = {
      ...newRateJson,
      rates: {
        // ...originalRateJson.rates,
        fcl: [...uniqueIdRateArr(originalRateJson.rates.fcl, newJsonArr)],
      },
    };

    dispatch({
      type: SET_SEA_FCL_JSON,
      payload: correctJson,
    });
  } else if (queryParams.type === 'api-lcl') {
    const newJsonArr =
      newRateJson && newRateJson.rates && newRateJson.rates.lcl;
    console.log('newJsonArr', newJsonArr);
    // if newJsonArr is empty then return
    if (Array.isArray(newJsonArr) && newJsonArr.length === 0) {
      console.log('empty newJsonArr, return');
      // if newJsonArr is empty then return
      return;
    }
    // old json rates fcl array + new json rates array

    correctJson = {
      ...newRateJson,
      rates: {
        // ...originalRateJson.rates,
        lcl: [...uniqueIdRateArr(originalRateJson.rates.lcl, newJsonArr)],
      },
    };
    console.log('correctJson', correctJson);
    dispatch({
      type: SET_SEA_LCL_JSON,
      payload: correctJson,
    });
  } else if (queryParams.type === 'api-air') {
    const newJsonArr =
      newRateJson && newRateJson.rates && newRateJson.rates.air;
    // console.log('newJsonArr', newJsonArr);
    // if newJsonArr is empty then return
    if (Array.isArray(newJsonArr) && newJsonArr.length === 0) {
      console.log('empty newJsonArr, return');
      // if newJsonArr is empty then return
      return;
    }

    // old json rates fcl array + new json rates array
    correctJson = {
      ...newRateJson,
      rates: {
        // ...originalRateJson.rates,
        air: [...uniqueIdRateArr(originalRateJson.rates.air, newJsonArr)],
      },
    };
    dispatch({
      type: SET_AIR_JSON,
      payload: correctJson,
    });
  }

  // update custom message
  updateCustomMessage(correctJson, dispatch);

  // update fcl/lcl/air json with correct zip code data
  // TODO-fix the arguments
  // why is it required though? full json is already have updated json with zipcode
  // updateJsonAfterPostalSubmit(getState, dispatch);

  // after remoovng old rates and adding new rates with unique id
  //ui nneds to be updated, it will update UI
  // it will update prices, tetc. but it will not re-sort cards
  dispatch({
    type: UPDATE_PICKUP_DELIVERY_ERS_LINE,
  });

  // reset rate cards state whether cards are expanded or not
  dispatch(updateRateCardsInfo(null));

  // sort rates cards, it will sort card according old sort
  dispatch(sortCards());

  // update sidebar checkboxes based on all cards
  updateSidebarRoleIncoterm(correctJson, dispatch);
};

// update custom message for search page cards
const updateCustomMessage = (fullJson, dispatch) => {
  const customMsgObj =
    (fullJson && !isEmpty(fullJson) && fullJson.custom_message) || {};
  dispatch({
    type: SET_SEARCH_CUSTOM_MESSAGE_JSON,
    payload: customMsgObj,
  });
};

// get rate item json array with unique id,
//if duplicat eid is found, get rid of old id, retain only new id
const uniqueIdRateArr2 = (oldItemsArr, newItemsArr) => {
  let tempOldItemsArr = [];

  // remove old item which is already present in new item array
  oldItemsArr.map((oldItem) => {
    let tempItem = { ...oldItem };

    newItemsArr.map((newItem) => {
      if (newItem.id === oldItem.id) {
        tempItem = null;
      }
    });

    tempItem && tempOldItemsArr.push(tempItem);
  });

  const finalArr = [...tempOldItemsArr, ...newItemsArr];

  // console.log({ finalArr });

  return finalArr;
};

// get rate item json array with unique id,
//if duplicat eid is found, get rid of old id, retain only new id
const uniqueIdRateArr = (oldItemsArr, newItemsArr) => {
  let finalArr = [];

  // add new obj with new id to old item arr
  const tempFinalArr = _.unionBy(oldItemsArr, newItemsArr, 'id');

  // replace old item with same id with new item with same id
  tempFinalArr.map((oldItem) => {
    let tempItem = { ...oldItem };

    newItemsArr.map((newItem) => {
      if (newItem.id === oldItem.id) {
        tempItem = { ...newItem };
        console.log('duplicate id:', oldItem.id);
      }
    });

    finalArr.push(tempItem);
  });

  // console.log({ finalArr });

  return finalArr;
};
